module.exports = __webpack_public_path__ + "img/BS32.221e0c65.svg";